export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10681.6ade0688.jpg";